// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"70d072c4","239":"6a609207","667":"fcf76ceb"}[chunkId] + ".chunk.js";
};